import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateTipoExpedienteRequest } from '@models/tipoExpediente/createTipoExpedienteRequest.model';
import { UpdateTipoExpedienteRequest } from '@models/tipoExpediente/updateTipoExpedienteRequest.model';

@Injectable({
  providedIn: 'root'
})
export class TipoExpedienteService {

  constructor(private http:HttpClient) {
  }

  create(createTipoExpedienteRequest:CreateTipoExpedienteRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/TipoExpediente/Create",createTipoExpedienteRequest);
  }

  update(updateTipoExpedienteRequest:UpdateTipoExpedienteRequest):Observable<any>
  {
    return  this.http.put<any>("/api/TipoExpediente/Update",updateTipoExpedienteRequest);
  }

  getAll():Observable<BaseDto[]> {
    return   this.http.get<BaseDto[]>("/api/TipoExpediente/GetAll");
  }

  getById(id:number):Observable<BaseDto>{
    return  this.http.get<BaseDto>("/api/TipoExpediente/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/TipoExpediente/Delete?id=" + id);
    else
      return of(null)
  }

}
